import ModalCover from 'components/shared/modal/ModalCover';
import React, { useContext, useEffect } from 'react';
import GuiContext from 'config/context/guiContext';
import styles from './MfImportModal.module.css';
import MfImportSteps from './MfImportSteps';
import MfImportFile from './MfImportFile';
import useTheme from 'config/useTheme';
import MfAddComposition from './MfAddComposition';
import MfAuthorization from './MfAuthorization';
import { MfImportProvider, useMfImport } from 'features/compositions/context/MfImportContext';
import MfDataTransmission from './MfDataTransmission';
import { useModalSystem } from 'config/context/ModalSystemContext';
import { odustani } from 'features/compositions/services/fileHandles';

const MfImportModalInner = () => {
  const { dark } = useTheme();
  const { step } = useMfImport();
  const { hideModal } = useModalSystem();
  const { URL } = useContext(GuiContext);

  // Zatvoren čarobnjak ne ostavlja otpremljen fajl na serveru do isteka.
  useEffect(() => () => { odustani(URL); }, [URL]);

  return (
    // Zatvaranje na klik van dijaloga je ukinuto. Koraci 1-3 drze kredencijale,
    // izbor tabela i izmene nad strukturom, a promasen klik ih je gubio bez
    // ijednog pitanja. Odustajanje sada ide iskljucivo preko dugmeta ispod.
    <ModalCover size='lg' closeOnOverlay={false}>
      <div className={`${styles.mf_modal} ${dark ? styles.dark : ''}`}>
        <h3>Upload a File</h3>
        <MfImportSteps />
        {step === 1 && <MfImportFile />}
        {step === 2 && <MfAddComposition />}
        {step === 3 && <MfAuthorization />}
        {step === 4 && <MfDataTransmission />}
        {/* U koraku 4 uvoz vec tece prema lancu; zatvaranje prozora ga ne bi
            zaustavilo, pa bi dugme obecavalo nesto sto ne moze. */}
        {step < 4 && (
          <div className={styles.mf_modal_actions}>
            <button type="button" onClick={hideModal}>Cancel import</button>
          </div>
        )}
      </div>
    </ModalCover>
  )
}

const MfImportModal = () => (
  <MfImportProvider>
    <MfImportModalInner />
  </MfImportProvider>
);

export default MfImportModal;
